import React from 'react';
import { Typography } from '@mui/material';
import { TipBox } from '../Guide.styles';
import { BRAND_COLORS } from '../../../styles/theme';
import { useTranslation } from '../../../i18n';

interface TipProps {
  children: React.ReactNode;
}

export const Tip: React.FC<TipProps> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <TipBox>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, color: BRAND_COLORS.forestGreen.main, mb: 0.5 }}
      >
        {t('guide.common.tip')}
      </Typography>
      <Typography variant="body2" sx={{ color: '#333' }}>
        {children}
      </Typography>
    </TipBox>
  );
};
